import { TASK_SERVICE, apiOptions, apiRequest } from "@miplatform/api";
import {
  IApiRequest,
  IApiResponse,
  IWorkOrder,
  IWorkOrderListResponse,
} from "@miplatform/types";

const API_WORK_ORDERS = `${TASK_SERVICE}/work-orders`;

export const workOrders = {
  getAll: async ({ filters, sort, top, skip }: IApiRequest = {}): Promise<
    IApiResponse<IWorkOrderListResponse[]>
  > => {
    const options = await apiOptions({
      filters,
      sort,
      top,
      skip,
      url: API_WORK_ORDERS,
    });

    return apiRequest(options);
  },

  getById: async ({
    id,
  }: {
    id: string;
  }): Promise<IApiResponse<IWorkOrder>> => {
    const options = await apiOptions({
      url: `${API_WORK_ORDERS}/${id}`,
    });

    return apiRequest(options);
  },
};
